export const LOCATION_TYPE = {
  DEFAULT: 'DEFAULT',
  VIEW: 'VIEW',
};
